
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressSavingsEN]",
      function () {
        return require("private-next-pages/[...wordpressSavingsEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressSavingsEN]"])
      });
    }
  